import { render, staticRenderFns } from "./FixedCollectionInputContainer.vue?vue&type=template&id=7ebc8848&scoped=true"
import script from "./FixedCollectionInputContainer.vue?vue&type=script&lang=js"
export * from "./FixedCollectionInputContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebc8848",
  null
  
)

export default component.exports